import { writable } from "svelte/store"


const StateReady = 's-ready'
const StateSearching = 's-searching'

const createSearchStateStore = () => {


	const { subscribe, set, update } = writable( StateReady )

	const setReady = () =>
		update( s => StateReady )
	const setSearching = () =>
		update( s => StateSearching )
	const isReady = () =>
		get( s ) === StateReady
	const isSearching = () =>
		get( s ) === StateSearching


	return {
		subscribe,
		set,
		update,
		setReady,
		setSearching,
		isReady,
		isSearching,
	}
}

export const searchState = createSearchStateStore()
